
import appRo from "@whatsappLang/ro/app.js";
import whatsappAccountsRo from "@whatsappLang/ro/whatsapp_accounts.js";
import whatsappCampaignsRo from "@whatsappLang/ro/whatsapp_campaigns.js";
import whatsappCampaignRecipientsRo from "@whatsappLang/ro/whatsapp_campaign_recipients.js";
import whatsappConversationsRo from "@whatsappLang/ro/whatsapp_conversations.js";
import whatsappContactsRo from "@whatsappLang/ro/whatsapp_contacts.js";
import whatsappMessagesRo from "@whatsappLang/ro/whatsapp_messages.js";
import whatsappTagsRo from "@whatsappLang/ro/whatsapp_tags.js";
import whatsappRecipientListsRo from "@whatsappLang/ro/whatsapp_recipient_lists.js";
import whatsappRecipientsRo from "@whatsappLang/ro/whatsapp_recipients.js";
import whatsappSentCampaignsRo from "@whatsappLang/ro/whatsapp_sent_campaigns.js";
import whatsappTemplatesRo from "@whatsappLang/ro/whatsapp_templates.js";
import whatsappOptInLogsRo from "@whatsappLang/ro/whatsapp_opt_in_logs.js";
import whatsappWebhookLogsRo from "@whatsappLang/ro/whatsapp_webhook_logs.js";

export default {
    en: {},
    ro: {
        app: appRo,
        whatsapp_accounts: whatsappAccountsRo,
        whatsapp_campaigns: whatsappCampaignsRo,
        whatsapp_campaign_recipients: whatsappCampaignRecipientsRo,
        whatsapp_conversations: whatsappConversationsRo,
        whatsapp_contacts: whatsappContactsRo,
        whatsapp_messages: whatsappMessagesRo,
        whatsapp_recipient_lists: whatsappRecipientListsRo,
        whatsapp_recipients: whatsappRecipientsRo,
        whatsapp_sent_campaigns: whatsappSentCampaignsRo,
        whatsapp_tags: whatsappTagsRo,
        whatsapp_templates: whatsappTemplatesRo,
        whatsapp_opt_in_logs: whatsappOptInLogsRo,
        whatsapp_webhook_logs: whatsappWebhookLogsRo,

    },
};
